// extracted by mini-css-extract-plugin
module.exports = {"cardTitle":"FrequentFlyerInput_cardTitle__NOou1","addBtn":"FrequentFlyerInput_addBtn__3PUT6","closeBtn":"FrequentFlyerInput_closeBtn__38tI7"};